export var Currency;
(function (Currency) {
    Currency["EURO"] = "EUR";
    Currency["POUND_STERLING"] = "GBP";
})(Currency || (Currency = {}));
export default function convertToCurrency(num, currency, locale) {
    const usableLocale = locale ?? document.documentElement.dataset.icuLocale ?? 'nl-NL';
    const formatter = new Intl.NumberFormat(usableLocale, {
        style: 'currency',
        currency: currency ?? Currency.EURO
    });
    return formatter.format(num);
}
export function convertCentsToCurrency(num, currency, locale) {
    return convertToCurrency(num / 100, currency, locale);
}
